import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Store, select } from "@ngrx/store";
import { clientConfig, errorMessages } from "../../shared/constant/app.constant";
import { NavButton } from "../../shared/components/navigation/next-button.component";
import { AppFlowService } from "../../shared/services/app-flow/app-flow.service";
import { SpinnerService } from "../../shared/services/spinner.service";
import { CopyHelpers } from "../../shared/helpers/copy.helpers";

@Component({
  selector: "app-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent {
  errorMessages = errorMessages;
  title = "";
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
    policyUrl: clientConfig.POLICYURL,
  };
  flowSteps = [];
  nextButton: NavButton = {
    buttonText: "startButton",
    routeUrl: "/m/returnitem",
    cssClass: "next-btn",
  };
  errorinfo = {
    title: "",
    message: "missingCriticalInfo",
  };
  orderData$: Observable<any>;
  orderDataRequired: any;
  orderData: any;
  param = { orderNumber: "" };

  constructor(
    private router: Router,
    private appFlowService: AppFlowService,
    private store: Store<AppState>,
    private spinnerService: SpinnerService
  ) {
    spinnerService.show();
    this.orderData$ = this.store.pipe(select("orderData"));
    this.nextButton.routeUrl = `/m/${this.appFlowService.findRouteFromSequence("welcome").next}`;
    const activeFlow = this.appFlowService.getActiveAppFlow();
    this.flowSteps = activeFlow.steps;
    this.orderDataRequired = activeFlow.orderDataRequired;
    spinnerService.hide();
    this.store.pipe(select("orderData")).subscribe((order) => {
      this.orderData = CopyHelpers.deepCopy(order);
    });

    this.param.orderNumber =
      this.orderData && this.orderData.orders && this.orderData.orders[0].orderNumber
        ? this.orderData.orders[0].orderNumber
        : "";

    if (this.orderData.errorMessage === "noReturnableItems") {
      this.errorinfo.title = "";
      this.errorinfo.message = "noReturnableItems";
    }
  }
}
